var map = {
	"./en/main": [
		9660,
		660
	],
	"./en/main.json": [
		9660,
		660
	],
	"./pl/main": [
		607,
		607
	],
	"./pl/main.json": [
		607,
		607
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 242;
module.exports = webpackAsyncContext;